module.exports = __webpack_public_path__ + "img/roll_d_f.470898c7.png";